<template>
	<v-btn v-if="isVisible" :small="small"
		   :x-small="xSmall"
		   icon
		   :disabled="isDisabled"
		   class="task-menu-btn"
		   @click.stop.prevent="onClick">
		<v-icon :small="small" :x-small="xSmall">{{ icon }}</v-icon>
	</v-btn>
</template>

<script>
import base from "@/mixins/base";

export default {
	name: "task-menu-btn",
	props: {
		item: {},
		small: {
			type: Boolean,
			default: false
		},
		xSmall: {
			type: Boolean,
			default: false
		},
	},
	mixins: [base],
	data: () => ({}),
	computed: {
		isVisible() {
			if (this.isTaskComment(this.item)) {
				return this.hasFullAccessToTask(this.item);
			}
			return true;
		},
		isDisabled() {
			return this.isAnon;
		},
		icon() {
			if (!this.hasFullAccessToTask(this.item)) return "mdi-lock-outline";
			return this.ui.taskMenu.isVisible && this.ui.taskMenu.item?.id === this.item.id ? "mdi-close" : "mdi-dots-horizontal";
		},
	},
	watch: {},
	methods: {
		onClick(event) {
			event.preventDefault();

			this.$store.dispatch("task/menu", {
				event,
				item: this.item,
			});
		},
	},
}
</script>

<style lang="scss">
.task-menu-btn {
}
</style>